/**
 * @file: 层板斜度
 * @author: xiaolong.huang@dmall.com
 */

import FrontCubeData from '../../../frontCubeData/index';

function renderSlop(cube: CubeNode): void {
    let slop: number = FrontCubeData.getNumberValue(cube.id, 'slope');
    let $slopText: JQuery<HTMLElement> = cube.jView.find('.slop-text');

    if (slop <= 0) {
        $slopText.addClass('slop-text--hide').removeClass('slop-text--show');
    }
    else {
        $slopText.removeClass('slop-text--hide').addClass('slop-text--show');
    }
    $slopText.text(`斜${slop}°`);
}

export {
    renderSlop
};
